/**
 * @generated SignedSource<<c8c70d9a28ea3599206bd10aee2009ac>>
 * @relayHash 00d6ac35c87a579e5adb71083b866f65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b6d2ee394aafe391104acabecce625dc0f0e18d26442b79566fa800ad16b0214

var node = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "commentId"
    },
    v2 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }, {
      "kind": "Variable",
      "name": "commentId",
      "variableName": "commentId"
    }, {
      "kind": "Literal",
      "name": "depth",
      "value": "ALL"
    }],
    v3 = {
      "kind": "ScalarField",
      "name": "parentId"
    },
    v4 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v5 = {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "container",
      "plural": false,
      "selections": [v4 /*: any*/, {
        "kind": "ScalarField",
        "name": "type"
      }, {
        "kind": "ScalarField",
        "name": "subType"
      }, {
        "kind": "ScalarField",
        "name": "status"
      }, {
        "kind": "ScalarField",
        "name": "currentUserIsWatching"
      }]
    },
    v6 = {
      "kind": "ScalarField",
      "name": "isInlineComment"
    },
    v7 = [{
      "kind": "ScalarField",
      "name": "resolved"
    }],
    v8 = {
      "kind": "InlineFragment",
      "selections": [{
        "concreteType": "InlineCommentResolveProperties",
        "kind": "LinkedField",
        "name": "inlineResolveProperties",
        "plural": false,
        "selections": v7 /*: any*/
      }],
      "type": "InlineComment"
    },
    v9 = {
      "kind": "InlineFragment",
      "selections": [{
        "concreteType": "InlineCommentResolveProperties",
        "kind": "LinkedField",
        "name": "commentResolveProperties",
        "plural": false,
        "selections": v7 /*: any*/
      }],
      "type": "FooterComment"
    };
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/],
      "kind": "Fragment",
      "name": "mainCommentDataQuery",
      "selections": [{
        "args": v2 /*: any*/,
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [{
          "concreteType": "CommentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [{
              "concreteType": "Comment",
              "kind": "LinkedField",
              "name": "replies",
              "plural": true,
              "selections": [v3 /*: any*/]
            }, v3 /*: any*/, v5 /*: any*/, v6 /*: any*/, {
              "kind": "LinkedField",
              "name": "location",
              "plural": false,
              "selections": [v8 /*: any*/, v9 /*: any*/]
            }]
          }]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v1 /*: any*/, v0 /*: any*/],
      "kind": "Operation",
      "name": "mainCommentDataQuery",
      "selections": [{
        "args": v2 /*: any*/,
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [{
          "concreteType": "CommentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [{
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [{
              "concreteType": "Comment",
              "kind": "LinkedField",
              "name": "replies",
              "plural": true,
              "selections": [v3 /*: any*/, v4 /*: any*/]
            }, v3 /*: any*/, v5 /*: any*/, v6 /*: any*/, {
              "kind": "LinkedField",
              "name": "location",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "name": "__typename"
              }, v8 /*: any*/, v9 /*: any*/]
            }, v4 /*: any*/]
          }]
        }]
      }]
    },
    "params": {
      "id": "b6d2ee394aafe391104acabecce625dc0f0e18d26442b79566fa800ad16b0214",
      "metadata": {},
      "name": "mainCommentDataQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "05fe6598682dd789894dee2fcd9be6ce";
export default node;